import { render, staticRenderFns } from "./dashboard_spklu.vue?vue&type=template&id=8f5479fa&scoped=true&"
import script from "./dashboard_spklu.vue?vue&type=script&lang=js&"
export * from "./dashboard_spklu.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_spklu.vue?vue&type=style&index=0&id=8f5479fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5479fa",
  null
  
)

export default component.exports